import { QueryHookOptions, useQuery } from '@apollo/client';

import { GET_CREATOR_DISCOVERY_SETTINGS_QUERY } from '../../queries';
import { GetCreatorDiscoverySettings } from '../../queries/types/GetCreatorDiscoverySettings';

type IOptions = QueryHookOptions<GetCreatorDiscoverySettings>;

export const useGetCreatorDiscoverySettingsQuery = (options: IOptions = {}) => {
  const { data, loading, error } = useQuery<GetCreatorDiscoverySettings>(GET_CREATOR_DISCOVERY_SETTINGS_QUERY, options);

  return {
    data: data?.getCreatorDiscoverySettings,
    loading,
    error,
  };
};
